$(function(){
    $('[js-article-video-play]').on('click', function(){
        var $frame = $(this),
            $container = $frame.closest('.article-widget')
        ;

        $frame.html('<iframe width="'+$container.width()+'" height="'+$container.height()+'" src="//www.youtube.com/embed/'+$(this).data('video-id')+'?autoplay=1" autoplay="1" frameborder="0" allowfullscreen></iframe>')
    });
});